import React, { useEffect, useState } from 'react';
import close from '../../assets/icons/close.svg';
import '../../assets/css/SearchBar.css';
import { getData } from '../../API/GlobalApi';
import arrowclockwise from '../../assets/icons/arrow-clockwise.svg';
import Select from 'react-select';
import { reactSelectStyles } from '../../Utils/selectBoxStyle';
import SpinnerLoader from '../../Utils/Spinner';
const initialStaticFilterOptions = {
  "Course/Program": [],
  "Academic Group": [],
  "Class": [],
  "Admission Status": [],
  "Cast Category": []
};

export const Filter = ({ setfiltermodal, setStudentsdata, setCurrentPage, setTotalCount, setFilterQueryString, fetchStudents, onClose, selectedValues, setSelectedValues, selectedSession, setSelectedSession, booleanStatus, setBooleanStatus, setSelectedOrgDetails }) => {
  const [selectedTab, setSelectedTab] = useState("Institute Name");
  const [orgs, setOrgs] = useState([]);
  const [dynamicOptions, setDynamicOptions] = useState({});
  const [courseIdMap, setCourseIdMap] = useState({});
  const [academicIdMap, setAcademicIdMap] = useState({});
  const [castCategoryMap, setCastCategoryMap] = useState({});
  const [loadingOrgs, setLoadingOrgs] = useState(false);
  const [loadingSessions, setLoadingSessions] = useState(false);
  const [loadingCourses, setLoadingCourses] = useState(false);
  // const [loadingAcademicGroups, setLoadingAcademicGroups] = useState(false);
  // const [loadingClasses, setLoadingClasses] = useState(false);


  const admissionStatusMap = {
    "Provisional Admission Confirmed": "provisional_fees_status",
    "Admission Confirmed": "registration_status",
  };

  const [sessions, setSessions] = useState([]);

  const getSessions = async () => {
    setLoadingSessions(true);
    try {
      const response = await getData("academics/academic-years/");
      const options = response?.map((session) => ({
        value: session.id,
        label: session.name,
        is_current: session.is_current,
      }));
      setSessions(options);
      // if (!selectedSession) {
      //   const currentSession = options.find((opt) => opt.is_current);
      //   if (currentSession) setSelectedSession(currentSession);
      // }
    } catch (err) {
      console.log("Error fetching sessions", err);
    } finally {
      setLoadingSessions(false);
    }
  };
  useEffect(() => {
    getSessions()
  }, [])

  useEffect(() => {
    const savedSelections = sessionStorage.getItem("filterSelections");
    if (savedSelections) setSelectedValues(JSON.parse(savedSelections));

    const savedBooleanStatus = sessionStorage.getItem("booleanSelections");
    if (savedBooleanStatus) setBooleanStatus(JSON.parse(savedBooleanStatus));

    getorgdata();
    getcastcategory();
  }, []);

  // useEffect(() => {
  //   if (selectedValues["Institute Name"]) getcoursedata(selectedValues["Institute Name"]);
  // }, [selectedSession]);


  useEffect(() => {
    if (selectedValues["Institute Name"] && orgs.length > 0) {
      getcoursedata(selectedValues["Institute Name"]);
    }
  }, [selectedValues["Institute Name"], orgs]);


  //   useEffect(() => {
  //   if (selectedValues["Institute Name"] && orgs.length > 0) {
  //     getcoursedata(selectedValues["Institute Name"]);
  //   }
  // }, [selectedValues["Institute Name"], orgs, selectedSession]);

  useEffect(() => {
    if (selectedValues["Course/Program"]) getacademicdata(selectedValues["Course/Program"]);
  }, [courseIdMap]);

  useEffect(() => {
    if (selectedValues["Academic Group"]) getclassdata(selectedValues["Academic Group"]);
  }, [academicIdMap]);

  useEffect(() => {
    sessionStorage.setItem("filterSelections", JSON.stringify(selectedValues));
  }, [selectedValues]);

  useEffect(() => {
    sessionStorage.setItem("booleanSelections", JSON.stringify(booleanStatus));
  }, [booleanStatus]);

  const getSelectedFiltersCount = () => {
    const filterKeys = Object.keys(selectedValues).filter(key => selectedValues[key]);
    const booleanKeys = Object.keys(booleanStatus).filter(key => booleanStatus[key] === "true");
    return filterKeys.length + booleanKeys.length;
  };

  const getSelectedFiltersDisplay = () => {
    const display = [];

    Object.entries(selectedValues).forEach(([key, value]) => {
      if (value) display.push(`${key}: ${value}`);
    });

    Object.entries(booleanStatus).forEach(([key, value]) => {
      if (value === "true") {
        const label = Object.entries(admissionStatusMap).find(([_, v]) => v === key)?.[0] || key;
        display.push(`${label}: ✅`);
      }
    });

    return display;
  };

  const getorgdata = async () => {
    setLoadingOrgs(true);
    try {
      const res = await getData("administration/organizations/");
      if (res) {
        const institutes = res?.map(org => ({
          name: org.organization_name || org.name,
          id: org.id
        }));
        setOrgs(institutes);
        setDynamicOptions(prev => ({
          ...prev,
          "Institute Name": institutes?.map(i => i.name)
        }));
      }
    } catch (err) {
      console.log("Error fetching organizations", err);
    } finally {
      setLoadingOrgs(false);
    }
  };


  const getcastcategory = async () => {
    const res = await getData('students/student-onboarding-basic-details/get-master-data/');
    const categories = res?.master?.student_categories;
    if (categories && Array.isArray(categories)) {
      const categoryNames = categories?.map(cat => cat.name);
      const idMap = Object.fromEntries(categories?.map(cat => [cat.name, cat.id]));
      setCastCategoryMap(idMap);
      setDynamicOptions(prev => {
        const updated = { ...prev, "Cast Category": categoryNames };
        if (selectedValues["Cast Category"] && categoryNames.includes(selectedValues["Cast Category"])) {
          setSelectedValues(prev => ({ ...prev }));
        }
        return updated;
      });
    }
  };


  const getcoursedata = async (orgName) => {
    setLoadingCourses(true);
    try {
      const org = orgs.find(o => o.name === orgName);
      if (!org) return;
      let url = `students/get-course-list-by-organization/?organization_id=${org.id}`;
      // if (selectedSession?.value) url += `&academic_year_id=${selectedSession.value}`;
      const res = await getData(url);
      if (res && Array.isArray(res)) {
        const courses = res?.map(r => {
          const name = r.course_specialization?.trim() || r.course?.name?.trim() || "Unnamed Course";
          return { name, id: r.id };
        });
        const nameList = courses?.map(c => c.name);
        const idMap = Object.fromEntries(courses?.map(c => [c.name, c.id]));
        setCourseIdMap(idMap);
        setDynamicOptions(prev => ({
          ...prev,
          "Course/Program": nameList,
          "Academic Group": [],
          "Class": []
        }));
      }
    } catch (err) {
      console.log("Error fetching courses", err);
    } finally {
      setLoadingCourses(false);
    }
  };

  const getacademicdata = async (courseName) => {
    const specializationId = courseIdMap[courseName];
    if (specializationId) {
      const res = await getData(`students/get-academic-groups-by-specialization/?specialization_id=${specializationId}`);
      if (res && Array.isArray(res)) {
        const groups = res?.map(r => ({ name: r.name, id: r.id }));
        const nameList = groups?.map(g => g.name);
        const idMap = Object.fromEntries(groups?.map(g => [g.name, g.id]));
        setAcademicIdMap(idMap);
        setDynamicOptions(prev => ({
          ...prev,
          "Academic Group": nameList,
          "Class": []
        }));
      }
    }
  };

  const [classIdMap, setClassIdMap] = useState({});

  const getclassdata = async (groupName) => {
    const academicId = academicIdMap[groupName];
    if (academicId) {
      const res = await getData(`students/get-least-academic-groups-by-academic-group/?academic_group_id=${academicId}`);
      if (res && Array.isArray(res)) {
        const classList = res?.map(r => r.name);
        const idMap = Object.fromEntries(res.map(r => [r.name, r.id]));
        setClassIdMap(idMap);
        setDynamicOptions(prev => ({
          ...prev,
          "Class": classList
        }));
      }
    }
  };


  const handleSelection = (tab, option) => {
    setSelectedValues(prev => ({ ...prev, [tab]: option }));
    if (tab === "Institute Name") getcoursedata(option);
    if (tab === "Course/Program") getacademicdata(option);
    if (tab === "Academic Group") getclassdata(option);
  };
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {

    setLoading(true); // start loader
    // Extract selected names
    const {
      "Institute Name": organizationName,
      "Course/Program": courseName,
      "Academic Group": academicGroupName,
      "Class": className,
      "Cast Category": category__name
    } = selectedValues;

    // Map names to IDs
    const organization_id = orgs.find(o => o.name === organizationName)?.id;
    const specialization_id = courseIdMap[courseName];
    const academic_group_id = academicIdMap[academicGroupName];
    const least_academic_group_id = classIdMap[className];

    // Prepare query params
    const queryParams = new URLSearchParams({
      ...(organization_id && { organization_id }),
      ...(selectedSession?.value && { academic_year_id: selectedSession.value }),
      ...(specialization_id && { specialization_id }),
      ...(academic_group_id && { academic_group_id }),
      ...(least_academic_group_id && { least_academic_group_id }),
      ...(category__name && { category__name }),
      ...booleanStatus,
    });


    setCurrentPage(0);              // reset pagination
    setFilterQueryString(queryParams.toString());
    setfiltermodal(false);

    // const queryStr = queryParams.toString();
    // try {
    //   const finalUrl = `students/get-students/?${queryStr}`;
    //   const res = await getData(finalUrl);

    //   if (res) {
    //     const results = res.results || [];

    //     if (results.length > 0) {
    //       // ✅ Data found
    //       setStudentsdata(results);
    //       setTotalCount(res.count || 0);
    //       setCurrentPage(0);

    //       setFilterQueryString(queryStr);
    //       setfiltermodal(false);
    //     } else {
    //       // ❌ No data found → reset org details
    //       setStudentsdata([]);
    //       setTotalCount(0);
    //       setSelectedOrgDetails(null); // 👈 Reset selected organization details
    //     }


    //   }
    // } catch (err) {
    //   console.log("error in filter", err);
    // } finally {
    //   setLoading(false); // stop loader
    //   setfiltermodal(false);
    // }
  };


  const handleReset = () => {
    // const currentSession = sessions.find(s => s.is_current) || null;
    // setSelectedSession(currentSession);
    setSelectedValues({});
    setDynamicOptions({});
    setBooleanStatus({
      provisional_fees_status: "",
      registration_status: ""
    });
    // setFilterQueryString("");
    // setSelectedOrgDetails(null);
    // onClose()
    sessionStorage.removeItem("filterSelections");
    sessionStorage.removeItem("booleanSelections");

    setCurrentPage(0);
    setFilterQueryString("");   // 🔥 triggers parent API
    onClose();

    // 7. IMPORTANT: Trigger fresh student API call
    //    Use a small timeout so modal closes nicely before fetch
    // setTimeout(() => {
    //   fetchStudents({ page: 0, query: null, filters: null });

    // }, 100);
    //  fetchStudents()
    // setStudentsdata([]);
    // setTotalCount(0);
    // setCurrentPage(0)
    // getorgdata();
    // getcastcategory();
  };

  const allFilterOptions = {
    "Institute Name": dynamicOptions["Institute Name"] || [],
    "Admission Year": [],
    ...initialStaticFilterOptions,
    ...dynamicOptions
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content"

        style={{
          maxWidth: "1000px",
          padding: "20px",
          background: "#F9FAFC",
          borderRadius: "10px",
          width: "50%",
          maxHeight: "83vh",
          overflow: "auto",
          display: "flex",
          flexDirection: "column"
        }}


      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 className="text-primary">Advance Filter</h2>
          <button className="close-btn" onClick={() => setfiltermodal(false)}>
            <img src={close} alt="Close" style={{ padding: "4px", background: '#F2F3F4', borderRadius: '50%' }} />
          </button>
        </div>

        <div style={{
          display: "flex",
          gap: "20px",
          flex: 1,              // 👈 take all available space
          overflow: "hidden",   // 👈 don't expand modal
          marginTop: "15px"
        }}>
          <div style={{ width: '30%', paddingRight: '10px', overflowY: 'scroll' }}>
            {Object.keys(allFilterOptions)?.map(tab => (
              <div
                key={tab}
                onClick={() => setSelectedTab(tab)}
                style={{
                  padding: '8px 10px',
                  background: selectedTab === tab ? '#F2EDFF' : 'transparent',
                  color: selectedTab === tab ? '#7F56DA' : '#000',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  marginBottom: '5px'
                }}
              >
                {tab}
              </div>
            ))}
          </div>
          <div
            style={{
              flexGrow: 1,
              flexBasis: 0,
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              paddingLeft: "10px",
              width: "70%",
              overflowY: "auto",
              justifyContent: (
                loadingOrgs && selectedTab === "Institute Name" ||
                loadingSessions && selectedTab === "Admission Year" ||
                loadingCourses && selectedTab === "Course/Program"
                // loadingAcademicGroups && selectedTab === "Academic Group" ||
                // loadingClasses && selectedTab === "Class"
              ) ? "center" : "flex-start",
              alignItems: (
                loadingOrgs && selectedTab === "Institute Name" ||
                loadingSessions && selectedTab === "Admission Year" ||
                loadingCourses && selectedTab === "Course/Program"
                // loadingAcademicGroups && selectedTab === "Academic Group" ||
                // loadingClasses && selectedTab === "Class"
              ) ? "center" : "flex-start",
              minHeight: "150px"
            }}
          >
            {/* Show loader if that tab is loading */}
            {selectedTab === "Institute Name" && loadingOrgs && <SpinnerLoader />}
            {/* {selectedTab === "Admission Year" && loadingSessions && <div>Loading Sessions...</div>} */}
            {selectedTab === "Course/Program" && loadingCourses && <SpinnerLoader />}
            {/* {selectedTab === "Academic Group" && loadingAcademicGroups && <SpinnerLoader />} */}
            {/* {selectedTab === "Class" && loadingClasses && <SpinnerLoader />} */}
            {selectedTab === "Admission Status" ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>
                {Object.entries(admissionStatusMap)?.map(([label, key]) => (
                  <label key={key} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="checkbox"
                      checked={booleanStatus[key] === "true"}
                      onChange={(e) =>
                        setBooleanStatus(prev => ({
                          ...prev,
                          [key]: e.target.checked ? "true" : ""
                        }))
                      }
                    />
                    {label}
                  </label>
                ))}
              </div>
            ) : selectedTab === "Admission Year" ? (
              <div style={{ width: '100%' }}>
                <label className="form-labell">Admission Year</label>
                <Select
                  options={sessions}
                  value={selectedSession}
                  isClearable
                  onChange={(opt) => {
                    setSelectedSession(opt || null);  // 👈 clear to null
                  }}

                  styles={reactSelectStyles}
                  placeholder="Select Session"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            ) :
              (
                allFilterOptions[selectedTab]?.map(option => (
                  <label key={option} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', margin: 0, whiteSpace: 'nowrap' }}>
                    <input
                      type="radio"
                      name={selectedTab}
                      value={option}
                      checked={selectedValues[selectedTab] === option}
                      onChange={() => handleSelection(selectedTab, option)}
                    />
                    {option}
                  </label>
                ))
              )}
          </div>
        </div>



        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
          <button className='btn' onClick={handleReset} style={{ color: 'red', cursor: 'pointer' }}>
            Reset Filters <img src={arrowclockwise} alt="reset" />
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {getSelectedFiltersCount() > 0 && (
              <div style={{ background: '#fff', padding: '10px', }}>
                <strong>Selected Filters ({getSelectedFiltersCount()})</strong>
              </div>
            )}
            <button
              className='btn btn-primary'
              onClick={handleSubmit}
              style={{ background: '#7F56DA', borderColor: '#7F56DA' }}
              disabled={loading} // optional: prevent double click
            >
              {loading ? <span className="spinner-border spinner-border-sm" role="status" /> : 'Submit'}
            </button>

          </div>

        </div>
      </div>
    </div>
  );
};